import React, { FC, ReactNode } from 'react';
import cx from 'classnames';

type TerritoryExploreListItemProps = {
  isMainFilterActive: boolean;
  onClick: () => void;
  children: ReactNode;
  className?: string;
  isSecondaryFilterActive?: boolean;
  isThirdFilterActive?: boolean;
};

export const TerritoryExploreListItem: FC<TerritoryExploreListItemProps> = ({
  isMainFilterActive,
  onClick,
  children,
  isSecondaryFilterActive,
  isThirdFilterActive,
}) => (
  <li
    onClick={onClick}
    className={cx(
      'relative shrink-0 min-w-[75px] text-center py-2 px-3 -ml-0 transition-all border border-t2-neutral-grey03 rounded-2xl hover:bg-t2-neutral-grey03 text-sm md:text-base cursor-pointer whitespace-nowrap',
      {
        'bg-t2-neutral-grey03': isMainFilterActive,
        '!bg-t2-shades-white !-ml-14 !z-10 transition-all': isSecondaryFilterActive && !isThirdFilterActive,
      },
    )}
  >
    {children}
  </li>
);
